export function shouldUseHomeMockFallback() {
  return (
    process.env.NODE_ENV === "development" &&
    process.env.NEXT_PUBLIC_ENABLE_HOME_AVI_MOCK_FALLBACK === "true"
  );
}
